import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc2015',
    ecrans: ['00-2'],
    params: ['?dccleint']
});
